import React from 'react';
import ContentModal from "../components/Content_modal/ContentModal";
import "../Content/Cards_sty.css";
import { img_300, unavailable } from "../not_found/config";
import { Badge } from "@material-ui/core";


const Cards = (props) => {
  return (
    <>
      <ContentModal media_type={props.media_type} id={props.id} >
      <Badge
        badgeContent={props.vote_average}
        color={props.vote_average > 6 ? "primary" : "secondary"}
      />
        <img className="card_poster" src={props.poster ? `${img_300}/${props.poster}` : unavailable} alt={props.title} />
        <b className='card_title'>{props.title}</b>
        <span className="card_subtitle" > {props.media_type === 'tv' ? "TV series" : "Movie"}</span>
        <span className="card_subtitle" > {props.date}</span>
      </ContentModal>
    </>
  );
}

export default Cards
